import type { Theme, ThemeStyle } from '@admin/shared/themes/default';

/**
 * Override styles for tab style.
 *
 * @param {Theme} theme - current theme
 *
 * @returns {ThemeStyle}
 */
export const getMuiTabStyle = (theme: Theme): ThemeStyle => {
  return {
    root: {
      textTransform: 'none',
      fontSize: 18,
      lineHeight: '21px',
      padding: 0,
      margin: '12px 15px',
      minWidth: 0,
      minHeight: 0,
      letterSpacing: 'normal',
      overflow: 'visible',

      [theme.breakpoints.up('xs')]: {
        minWidth: 0,
      },

      '&:first-of-type': {
        marginLeft: 0,
      },
    },

    textColorPrimary: {
      color: theme.palette.grey['300'],
      '&$selected': {
        opacity: 1,
        color: theme.palette.text.primary,
      },
      '&:hover': {
        color: theme.palette.grey['600'],
      },
      '&$disabled': {
        opacity: 0.5,
      },
    },

    selected: {
      color: theme.palette.text.primary,
    },
  };
};
